var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCodeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3315",
    "data-name": "Groupe 3315",
    transform: "translate(-1180 -558)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "qr_code",
    "data-name": "qr code",
    transform: "translate(1189.146 567.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_13",
    "data-name": "Union 13",
    d: "M2.26,30.455A2.261,2.261,0,0,1,0,28.194V18.469a2.259,2.259,0,0,1,2.26-2.256h9.726a2.259,2.259,0,0,1,2.257,2.256v9.726a2.26,2.26,0,0,1-2.257,2.261ZM2.354,28.1h9.534V18.566H2.354Zm24.219,2.259a.545.545,0,0,1-.542-.541V26.573a.545.545,0,0,1,.542-.541h3.242a.545.545,0,0,1,.541.541v3.242a.545.545,0,0,1-.541.541Zm-9.726,0a.545.545,0,0,1-.541-.541V27.653a.545.545,0,0,1,.541-.538h2.159a.544.544,0,0,1,.541.538v2.162a.545.545,0,0,1-.541.541Zm4.322-4.324a.543.543,0,0,1-.542-.538V21.169a.545.545,0,0,1,.542-.538h4.325a.544.544,0,0,1,.538.538v4.325a.542.542,0,0,1-.538.538Zm-16.209,0a.543.543,0,0,1-.541-.538V21.169a.545.545,0,0,1,.541-.538H9.281a.544.544,0,0,1,.541.538v4.325a.542.542,0,0,1-.541.538Zm11.888-5.4a.545.545,0,0,1-.541-.541V16.848a.545.545,0,0,1,.541-.541H20.09a.542.542,0,0,1,.538.541V20.09a.542.542,0,0,1-.538.541Zm10.805-1.083a.545.545,0,0,1-.542-.538V16.848a.545.545,0,0,1,.542-.541h2.162a.545.545,0,0,1,.541.541V19.01a.544.544,0,0,1-.541.538Zm-9.184-5.306a2.259,2.259,0,0,1-2.26-2.256V2.261A2.263,2.263,0,0,1,18.469,0h9.725a2.262,2.262,0,0,1,2.257,2.261v9.726a2.259,2.259,0,0,1-2.257,2.256Zm.1-2.354H28.1V2.357h-9.53ZM2.26,14.242A2.259,2.259,0,0,1,0,11.986V2.261A2.263,2.263,0,0,1,2.26,0h9.726a2.262,2.262,0,0,1,2.257,2.261v9.726a2.259,2.259,0,0,1-2.257,2.256Zm.094-2.354h9.534V2.357H2.354ZM21.169,9.824a.543.543,0,0,1-.542-.538V4.961a.545.545,0,0,1,.542-.538h4.325a.544.544,0,0,1,.538.538V9.286a.542.542,0,0,1-.538.538Zm-16.209,0a.543.543,0,0,1-.541-.538V4.961a.545.545,0,0,1,.541-.538H9.281a.544.544,0,0,1,.541.538V9.286a.542.542,0,0,1-.541.538Z",
    transform: "translate(2.629 2.627)",
    fill: "#3e3e3e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeIcon);
export default __webpack_public_path__ + "static/media/qrCodeIcon.c2a735e18b4cfbc4777e6edf393236e0.svg";
export { ForwardRef as ReactComponent };